import blogPosts from "@/data/blogPosts";
import { getFallbackCaseStudiesForAdmin } from "@/lib/cms";

export interface SearchResult {
  title: string;
  description: string;
  url: string;
  type: "Page" | "Blog" | "Service" | "FAQ" | "Case Study";
}

const staticPages: SearchResult[] = [
  { title: "Home", description: "MVIBE — Coaching, Training & Consulting", url: "/", type: "Page" },
  { title: "About Us", description: "Meet Mahirah, founder of MVIBE — Executive Facilitator, Life Coach, Soft Skills Trainer", url: "/about", type: "Page" },
  { title: "Contact Us", description: "Book a discovery call with MVIBE. Coaching, training, consulting enquiries.", url: "/contact", type: "Page" },
  { title: "Case Studies", description: "Real transformations and results from MVIBE coaching and training programmes.", url: "/case-studies", type: "Page" },
  { title: "Blog", description: "Insights on leadership, coaching, personal growth from Mahirah.", url: "/blog", type: "Page" },
  { title: "Privacy Policy", description: "How MVIBE collects, uses, and protects personal information.", url: "/privacy", type: "Page" },
  { title: "Terms of Service", description: "MVIBE website and service terms.", url: "/terms", type: "Page" },
  { title: "Cookie Policy", description: "How MVIBE uses cookies and similar technologies.", url: "/cookies", type: "Page" },
  { title: "Disclaimer", description: "Important website and service disclaimer information.", url: "/disclaimer", type: "Page" },
  { title: "Services for Individuals", description: "Life coaching, personal branding, image consulting, career clarity for working professionals.", url: "/services/individuals", type: "Service" },
  { title: "Services for Organisations", description: "Corporate soft skills training, leadership development, campus-to-corporate, systems thinking.", url: "/services/companies", type: "Service" },
  { title: "Life Coaching", description: "Career clarity, burnout recovery, leadership identity, goal alignment for working professionals.", url: "/services/individuals", type: "Service" },
  { title: "Personal Branding & Image Consulting", description: "Personalized style coaching, strategic use of colors, body language mastery, wardrobe curation.", url: "/services/individuals", type: "Service" },
  { title: "Executive Facilitation & Leadership Training", description: "Soft skills and behavioural training for CXOs, DGMs, and senior leadership teams.", url: "/services/companies", type: "Service" },
  { title: "Campus-to-Corporate Training", description: "Interview readiness, communication skills, professional etiquette for students and graduates.", url: "/services/companies", type: "Service" },
  { title: "Graphology (Handwriting Analysis)", description: "Handwriting analysis for self-discovery, personality insights, and personal development.", url: "/services/individuals", type: "Service" },
  { title: "ART Therapy", description: "Stress management through art therapy, creative expression, and emotional well-being.", url: "/services/individuals", type: "Service" },
];

const faqResults: SearchResult[] = [
  { title: "What is MVIBE?", description: "MVIBE is a transformative coaching, training, and consulting firm founded by Mahirah.", url: "/", type: "FAQ" },
  { title: "Who is the founder of MVIBE?", description: "Mahirah (Sana Amrin) — Executive Facilitator, Soft Skills Trainer, ICF-aligned Life Coach with 15+ years experience.", url: "/about", type: "FAQ" },
  { title: "How to book a discovery call?", description: "Contact via the website, WhatsApp, email, or LinkedIn.", url: "/contact", type: "FAQ" },
];

const blogResults: SearchResult[] = blogPosts.map((p) => ({
  title: p.title,
  description: p.excerpt,
  url: `/blog/${p.slug}`,
  type: "Blog" as const,
}));

const caseStudyResults: SearchResult[] = getFallbackCaseStudiesForAdmin().map((study) => ({
  title: study.title,
  description: study.summary,
  url: `/case-studies/${study.slug}`,
  type: "Case Study" as const,
}));

const allResults: SearchResult[] = [...staticPages, ...faqResults, ...blogResults, ...caseStudyResults];

export function searchSite(query: string): SearchResult[] {
  if (!query.trim()) return [];
  const q = query.toLowerCase();
  return allResults.filter((r) => r.title.toLowerCase().includes(q) || r.description.toLowerCase().includes(q)).slice(0, 8);
}
